import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import notificationsActions from '../../notifications/action-creators';
import taskGroupsActions from './task-groups';

const taskGroupTasksActions = {
  addTaskToTaskGroup(formData) {
    return async (dispatch) => {
      const post = { ...formData };
      // Remove redundant
      delete post.taskGroupGuid;
      dispatch(this.setIsLoading('addTaskToTaskGroup'));
      const data = await ApiService.post(`/api/v1/task-groups/${formData.taskGroupGuid}/tasks`, post)
        .then(response => response.data)
        .catch(error => ({ error }));

      dispatch(this.setIsLoading('addTaskToTaskGroup'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.addTaskToTaskGroupSuccess(data));
      }
      return Promise.resolve();
    };
  },
  addTaskToTaskGroupSuccess(taskGroupResponse) {
    return async (dispatch) => {
      dispatch(taskGroupsActions.replaceTaskGroup(taskGroupResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Added'));
    };
  },
  removeTaskFromTaskGroup(taskGroupGuid, taskGuid) {
    return async (dispatch) => {
      dispatch(taskGroupsActions.setIsLoading('removeTaskFromTaskGroup'));
      const data = await ApiService.delete(`/api/v1/task-groups/${taskGroupGuid}/tasks/${taskGuid}`)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(taskGroupsActions.setIsLoading('removeTaskFromTaskGroup'));
      if (data.error) {
        commonActions.handleApiError(data.error);
      } else {
        dispatch(this.removeTaskFromTaskGroupSuccess(data));
      }
    };
  },
  removeTaskFromTaskGroupSuccess(updated) {
    return (dispatch) => {
      dispatch(taskGroupsActions.replaceTaskGroup(updated.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Group updated'));
    };
  },
  updateTaskGroupTask(formData) {
    return async (dispatch) => {
      const patch = { ...formData };
      // Remove redundant
      delete patch.taskGuid;
      dispatch(this.setIsLoading('updateTaskGroupTask'));
      const data = await ApiService.patch(`/api/v1/task-group-tasks/${formData.taskGuid}`, patch)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateTaskGroupTask'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateTaskGroupTaskSuccess(data));
      }
      return Promise.resolve();
    };
  },
  updateTaskGroupTaskSuccess(taskGroupResponse) {
    return async (dispatch) => {
      dispatch(taskGroupsActions.replaceTaskGroup(taskGroupResponse.data));
      dispatch(notificationsActions.addSavedSuccessfully('Task Updated'));
    };
  },
};

export default taskGroupTasksActions;
